import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-varsel",
  "use": "icon-varsel-usage",
  "viewBox": "0 0 56.27 48.96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56.27 48.96\" id=\"icon-varsel\"><title>ikon varseltrekant</title><path d=\"M55.27,49H1a1,1,0,0,1-.87-.5,1,1,0,0,1,0-1L27.27.46A1,1,0,0,1,29,.46l27.14,47a1,1,0,0,1,0,1A1,1,0,0,1,55.27,49ZM2.73,47H53.54L28.14,3Z\" style=\"fill:#000222\" /><path d=\"M29.82,22.18l-.68,11.76a1,1,0,0,1-1.06,1,1,1,0,0,1-.94-1l-.69-11.76a1.69,1.69,0,0,1,3.37-.2Z\" style=\"fill:#000222\" /><circle cx=\"28.14\" cy=\"38.88\" r=\"1.62\" style=\"fill:#000222\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol